import { render } from "./InfoGraphicForm.vue?vue&type=template&id=9d04c2cc&ts=true"
import script from "./InfoGraphicForm.ts?vue&type=script&lang=ts"
export * from "./InfoGraphicForm.ts?vue&type=script&lang=ts"

import "./InfoGraphicForm.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__